module.exports = __webpack_public_path__ + "static/img/img_banner_05.fefc63e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_banner_05.jpg
// module id = pMy1
// module chunks = 11